var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 192 192",
    style: {
      enableBackground: "new 0 0 192 192"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#00D1FF;}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.63 -97.669)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -257.63 97.669)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1621.4948,
    y1: 225.4892,
    x2: 1621.4948,
    y2: -30.5108,
    gradientTransform: "matrix(0.75 0 0 -0.75 -853.2712 169.1148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#090220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#170659"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 362.8,
    cy: 362.8,
    r: 362.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.3,272.6c-2.9-3.6-7.3-5.6-12-5.6h-96.9c-0.8,0-1.5-0.3-2.1-0.8c-0.5-0.5-0.8-1.1-0.8-1.8v-65.3 c0-0.7,0.3-1.3,0.8-1.8c0.6-0.6,1.3-0.9,2.1-0.8h102.4c25.8,0,48.1,10.6,66.9,31.7l24.9,30.4l-48.5,59.1L243.3,272.6z  M422.3,227.9c18.7-20.9,41.1-31.4,67.2-31.4h102.1c0.7-0.1,1.4,0.2,1.9,0.6c0.5,0.5,0.7,1.2,0.6,2v65.3c0,0.7-0.2,1.3-0.6,1.8 c-0.5,0.6-1.2,0.9-1.9,0.8h-96.9c-4.6-0.1-9,2-12,5.6l-71.4,86.9L483,447c2.9,3.3,7.2,5.3,11.6,5.2h96.9c0.7-0.1,1.5,0.3,1.9,0.8 c0.4,0.6,0.7,1.4,0.6,2.1v65.3c0,0.7-0.2,1.3-0.6,1.8c-0.5,0.6-1.2,0.9-1.9,0.8H489.5c-26.1,0-48.3-10.6-66.9-31.7l-59.4-72.5 l-59.4,72.5c-18.7,21.1-41.1,31.7-67.2,31.7H134.4c-0.7,0.1-1.5-0.3-1.9-0.8c-0.5-0.6-0.7-1.4-0.6-2.1v-65.3 c0-0.7,0.2-1.3,0.6-1.8c0.5-0.6,1.2-0.9,1.9-0.8h96.9c4.6,0,9-2.1,12-5.6l70.1-85.6L422.3,227.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnx);
export default __webpack_public_path__ + "static/media/SNX.33a63b7ff36bfee20a6c308ed0796637.svg";
export { ForwardRef as ReactComponent };